import { FC } from 'react';
import Nav from 'react-bootstrap/Nav';
import { NavLinkProps } from 'react-bootstrap/NavLink';
import styles from './TabItem.module.css';
import cn from 'classnames';

interface TabItemProps extends NavLinkProps {
  title: string;
  id: string;
}

const TabItem: FC<TabItemProps> = ({ title, id, ...props }) => {
  return (
    <Nav.Item>
      <Nav.Link eventKey={id} {...props} className={cn(styles.navLink)}>
        {title}
      </Nav.Link>
    </Nav.Item>
  );
};

export default TabItem;
